export type KpiStatus = 'ok' | 'warn' | 'crit' | 'info';

export function KpiCard({
  label,
  value,
  hint,
  status,
}: {
  label: string;
  value: string;
  /** Petite phrase sous le chiffre : ce qu'il faut en comprendre, pas juste le répéter. */
  hint?: string;
  /** Colore le chiffre pour signaler un état à surveiller (aucune alerte = pas de couleur). */
  status?: KpiStatus;
}) {
  return (
    <div className={`kpi${status ? ` kpi-${status}` : ''}`}>
      <span className="kpi-lbl">{label}</span>
      <div className="kpi-val">{value}</div>
      {hint && <div className="kpi-hint">{hint}</div>}
    </div>
  );
}

export function MetricCard({ label, value }: { label: string; value: string }) {
  return (
    <div className="metric">
      <div className="lbl">{label}</div>
      <div className="val">{value}</div>
    </div>
  );
}
